module.exports = __webpack_public_path__ + "static/media/login-banner-purple.f50e4eeb.jpg";